import React from 'react'
import socketio from 'socket.io-client'

export const socket = socketio(process.env.REACT_APP_SOCKET_URL, {
  auth: (cb) => {
    const token = { token: window.sessionStorage.getItem('token') }
    cb(token)
  }
})

export const SocketContext = React.createContext()
